<template>
    <div>
        author页面
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            arr: []
        };
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/hospital-admin/pages/author.vue